/* eslint-disable @typescript-eslint/no-explicit-any */
import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  inject,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { PlaceholderReplacePipe } from "src/app/shared/pipes/placeholder-replace/placeholder-replace.pipe";

@Component({
  selector: "app-common-alert-modal",
  templateUrl: "./common-alert-modal.component.html",
  styleUrls: ["./common-alert-modal.component.scss"],
  imports: [TranslateModule, PlaceholderReplacePipe, CommonModule, FormsModule],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommonAlertModalComponent implements OnChanges {
  @Input() title = "";
  @Input() message = "";
  @Input() cancelBtnTitle = "";
  @Input() actionBtnTitle = "";
  @Input() isModalOpen = false;
  @Input() actionType = "";
  @Input() placeholderObject: any;
  @Input() hideSecondaryBtn = "";
  @Output()
  isModalResponseClicked = new EventEmitter<any>();
  private readonly _cdr = inject(ChangeDetectorRef);
  translationData: any;
  showCheckBox: boolean = false;
  isChecked: boolean = true;

  onCancel() {
    this.isModalResponseClicked.emit({ action: false });
  }

  onAction() {
    this.isModalResponseClicked.emit({
      action: true,
      actionType: this.actionType,
      checkBoxValue:
        this.actionType === "FLORA_FAUNA_CONFIRMATION" ? this.isChecked : false,
    });
  }

  ngOnChanges(): void {
    this.translationData = this.placeholderObject;
    if (this.actionType === "FLORA_FAUNA_CONFIRMATION") {
      this.showCheckBox = true;
    }
    this._cdr.markForCheck();
  }
}
